import SubmitResume from './pc/submitResume.vue'
import MobileSubmitResume from './mobile/submitResume.vue'
import { deviceType } from '@/utils/common'
import RootLayout from '../layout/rootLayout.vue'
import BlankLayout from '../layout/blankLayout.vue'

const basePath = '/recruiting/personal/referral/submit'

const submitRoute = {
  name: 'submitResume',
  path: `${basePath}/resume`,
  component: deviceType.isPc ? SubmitResume : MobileSubmitResume,
  meta: {
    rootLayout: {
      hiddenLeftPadding: true
    },
    personalLayout: {
      blankPage: true
    },
    titleI18nKey: 'personal.resume.tabTitle.submitResume',
    menuI18nKey: 'personal.resume.tabTitle.submitResume'
  }
}

export default {
  name: 'newPersonalReferralsIndex',
  path: `${basePath}`,
  component: deviceType.isPc ? RootLayout : BlankLayout,
  redirect: submitRoute.path,
  meta: {
    isInclude: false,
    rootLayout: {
      hiddenBackgroundImage: true,
      hiddenTabList: true,
      flexMode: true
    }
  },
  children: [
    submitRoute
  ]
}
